import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import open from './open.js'

export default contract({
  open: array([
    open
  ])
})
